import { FILES_ENDPOINT, PROJECTS_ENDPOINT, REPORTS_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import {
  DownloadFileResponse,
  DownloadFilestreamFileRequest,
  DownloadRlSafeReportRequest,
  DownloadRlSafeReportResponse,
  DownloadVersionRequest,
  ReportArchiveRequest,
  ReportArchiveResponse,
} from "../types";

const fileTransferApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    downloadFilestreamFile: builder.query<
      DownloadFileResponse,
      DownloadFilestreamFileRequest
    >({
      query: (params) => `${FILES_ENDPOINT}/file/${params.file_id}/download`,
    }),
    downloadVersion: builder.query<
      DownloadFileResponse,
      DownloadVersionRequest
    >({
      query: (params) => ({
        url: `${PROJECTS_ENDPOINT}/versions/${params.version_id}/download`,
        params: {
          repro: params.repro,
        },
      }),
    }),
    downloadRlSafeReport: builder.query<
      DownloadRlSafeReportResponse & { fetchedAt: string },
      DownloadRlSafeReportRequest
    >({
      query: (params) => ({
        url: `${REPORTS_ENDPOINT}/exports/${params.report_id}/rl-safe`,
      }),
      transformResponse: (data: DownloadRlSafeReportResponse) => {
        return {
          ...data,
          fetchedAt: new Date().toISOString(),
        };
      },
    }),
    getReportArchive: builder.query<
      ReportArchiveResponse,
      ReportArchiveRequest
    >({
      query: ({ report_id }) =>
        `${REPORTS_ENDPOINT}/exports/${report_id}/report-archive`,
    }),
  }),
});

export const {
  useDownloadFilestreamFileQuery,
  useDownloadVersionQuery,
  useDownloadRlSafeReportQuery,
  useGetReportArchiveQuery,
} = fileTransferApi;
